export default __webpack_public_path__ + "freeweekend-locales/ko-KR.798aeb7f9ddc4c11be3fdce75efb67de.json";